import api from '../utils/api';

export const sendRRHH = async (params: any, language: string) => {
  try {
    const response = await api.post('/api/emails/send', {
      Tipo: 'RRHH',
      NombreCompleto: `${params.firstName} ${params.lastName}`,
      CorreoElectronico: params.email,
      Telefono: params.phone,
      Experiencia: params.message,
      Curriculum: params.cv,
      Idioma: language,
    });
    return response.data;
  } catch (err) {
    return { Result: false };
  }
};
